<template>
 <div class="rechargeable">
    <div  style="overflow: auto; height: 90%;">
        <!-- 下拉刷新组件 -->
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <!-- 列表组件 -->
      <van-list v-model="loading" :finished="finished" :finished-text="bomTitle" @load="onLoad" :offset="20">
        <div class="list" v-if="list.length > 0">
          <div class="list_item b-b" v-for="(item, index) in list" :key="index">
            <van-image v-if="item.withdrawalType == 3" class="typeIcon" :src="require('@/assets/img/bank.png')" ></van-image>
            <van-image v-if="item.withdrawalType == 2" class="typeIcon" :src="require('@/assets/img/zhifubao.png')" ></van-image>
            <van-image v-if="item.withdrawalType == 1" class="typeIcon" :src="require('@/assets/img/weixing.png')" ></van-image>
            <div class="jiao" v-if="item.examineStatus == 0"><van-image :src="require('@/assets/img/wait_pass.png')" width="4rem"  height="1.2rem"></van-image></div>
            <div class="jiao" v-if="item.examineStatus == 1"><van-image :src="require('@/assets/img/yes_pass.png')" width="4rem" height="1.2rem"></van-image></div>
            <div class="jiao" v-if="item.examineStatus == 2"><van-image :src="require('@/assets/img/not_pass.png')" width="4rem" height="1.2rem"></van-image></div>
            <div class="item_l">
              <div class="text1 mb20">{{typeList[item.withdrawalType]}}</div>
              <div class="text2">{{item.createTime}}</div>
            </div>
            <div class="item_r">
              <div class="text1 mb20" style="color: chocolate;"><span style="font-size: 16px;color: #fff;">提现金额:</span> -{{item.withdrawalMoney}}</div>
              <div class="text2">余额: {{item.balance}}</div>
            </div>
            </div>
        </div>
        <div class="no_data" v-else>
          <div>
              <van-empty description="暂无数据" />
          </div>
        </div>
</van-list>
  </van-pull-refresh>
   </div>
<van-popup v-model="show" bind:close="onClose"  catchtouchmove='true' position="bottom" round closeable>
  <div class="alert">
    <div class="title">提现</div>
    <div class="info"><i style="font-weight:700">提现提醒说明:</i>请确认好银行信息, 如需更换请修改个人信息资料</div>
    <div class="alert_item">
      <div class="alert_item_l">银行名称:</div>
      <div class="alert_item_r">{{userInfo.bankName}}</div>
    </div>
    <div class="alert_item">
      <div class="alert_item_l">银行卡号</div>
      <div class="alert_item_r">{{userInfo.bankCard}}</div>
    </div>
    <div class="alert_item">
      <div class="alert_item_l">姓名:</div>
      <div class="alert_item_r">{{userInfo.userName}}</div>
    </div>
    <div class="alert_item">提现金额: <input type="text" placeholder="请输入金额" maxlength="8" v-model="money"   placeholder-class="placeholder" @blur="blurHandler" />元</div>
    <div  class="alert_item_real"><div>实际到账金额=提现金额-手续费: {{ realMoney }}元</div></div>
    <div class="chonglist">
      <div class="item"  :class= "{ 'select':index == chongFlag}"  v-for="(item, index) in moneyList" :key="index"  @click="changeMoney(item,index)">{{item}}</div>
    </div>
    <div class="alert_item">提现密码: <input type="text" placeholder="请填写密码" maxlength="20" v-model="withDrawPassword"   placeholder-class="placeholder"/></div>
    <div class="button" @click="release">保存</div>
  </div>
</van-popup>

<BackButton @back="setWithDrawal" ><div class="recharge_but">我要提现</div></BackButton>
</div>
</template>

<script>

import { getWithDrawalList,addWithDrawal,getConfig } from "@/api/withdrawal.js";
import { moneyFmt } from "@/utils/moneyUtil";
import { checkStrNotNull,formatMoney } from "@/utils/common.js";

export default {
  name: "WithDrawalPage",
  data() {
    return {
      userInfo: this.$store.state.user.userInfo,
      pageNum: 1,
      total: 0,
      typeList: ['微信', '支付宝', '银行卡'],
      list: [],
      moneyList: [10000, 15000, 20000],
      chongFlag: undefined,
      money: '',
      realMoney:'',
      show: false,
      remark: '',
      isLoading: false, // 控制下拉刷新的加载状态
      loading: false, // 控制上拉加载的加载状态
      finished: true, // 是否已加载完全部数据
      bomTitle: '', // 上拉加载完成时的文本
      withDrawPassword:'',
      withdrawalFees:0.97,
      minWithdrawal: 0,
      incomeAmount: 0,
    };
  },
    created() {
       let query = this.$route.query;
       console.log(query)
       if(query.incomeAmount){
        this.incomeAmount = query.incomeAmount;
       }
       this.config('withdrawal_fees','withdrawalFees');
       this.config('min_withdrawal','minWithdrawal');
       this.informPort(true)
  },
  methods: {
    config(key,dataKey){
     getConfig(key).then((res) => {
        if (res.code == 200) {
          this[dataKey]= res.data;
        }
       })
    },
    setWithDrawal(){
    //验证账户信息是否存在
    if(!checkStrNotNull(this.userInfo.bankName) || !checkStrNotNull(this.userInfo.userName) ||!checkStrNotNull(this.userInfo.bankCard)){
      this.$toast.fail({message: '请完善个人信息的邀请码后再试',duration: 3500})
      return;
    }
      this.show =true
    },
      // 获取列表数据
    informPort(flag) {
      getWithDrawalList(this.pageNum).then(res => {
        console.log(res)
        if (res.code == 200 && res.rows) {
          console.log(res)
          let dataList = res.rows
          if (dataList && dataList.length) {
            if (flag) {
              this.list = dataList
            } else {
              this.list = [...this.list, ...dataList]
            }
          }
          this.total = res.total
          this.loading = false
          this.finished = false
          if (this.list.length >= this.total) {
            this.bomTitle = '到底了~ ' + '共计' + res.total + '条'
            this.finished = true
          } else {
            this.pageNum += 1
            this.bomTitle = ''
          }
        }
      })
    },
     // 下拉刷新
    onRefresh() {
      this.pageNum = 1
      this.finished = true
      this.loading = true
      this.list = []
      this.isLoading =true
      setTimeout(() => {
        this.isLoading = false // 结束下拉刷新的加载状态
        this.informPort(true) // 重新获取列表数据
        this.$toast.success('刷新成功')
      }, 300)
    },
    // 上拉加载
    onLoad() {
      this.informPort() 
      // 获取更多列表数据
      
    },
    changeMoney(item,index) {
      this.money = item
      this.chongFlag = index;
      console.log(index)
      console.log(this.chongFlag)
      this.blurHandler();
    },
    blurHandler(){
       let money = this.money.toString();
       let amount = formatMoney(money);
      let realMoney = (amount*this.withdrawalFees).toFixed(2);
      this.realMoney = realMoney
    },
    release() {
      if(!this.money || this.money < parseFloat(this.minWithdrawal)){
        this.$toast.fail({message: '金额必须大于'+this.minWithdrawal,duration: 3000})
        return;
      }
      console.log(this.money)
    if(this.money && this.money > parseFloat(this.incomeAmount)){
      this.$toast.fail({message: '提现金额不能超过账户余额',duration: 3000})
      return;
    }
    if(!checkStrNotNull(this.withDrawPassword)){
      this.$toast.fail({message: '请输入提现密码',duration: 3000})
      return;
    }
    let params = {
      withdrawalsMoney: this.money,
      realMoney: this.realMoney,
      withDrawPassword: this.withDrawPassword,
      sysType: 2
    }
    addWithDrawal(params).then(res => {
      if (res.code != 200) {
        this.$toast.fail({message: res.msg,duration: 3000})
      }else{
        this.$toast.success({message: "操作成功",duration: 3000})
        this.show = false;
        this.money= '';
        this.realMoney= 0;
        this.withDrawPassword= '';
        setTimeout(() => {
          this.onRefresh();
        }, 2000)
      }
    })
  },
  },
};
</script>

<style lang="less" scoped>
.rechargeable {
   width: 100%;
   height: 100vh;
   background: url(@/assets/img/team_bg.png) no-repeat left center;
   background-size: 100% 100%;
   overflow: hidden;
}

.list {
  padding-bottom: 16px;
}
.list .list_item {
  display: flex;
  align-items: center;
  padding: 25px 16px;
  position: relative;
  background-color: #516388;
  margin-top: 1px;
  padding-bottom: 12px;
}
.list .list_item .jiao {
  position: absolute;
  right: 0;
  top: 0;
}
.list .list_item .jiao img {
  width: 64px;
  height: 18px;
}
.list .list_item .jiao .wait {
  width: 52px;
}
.list .list_item .jiao .not {
  width: 76px;
}
.list .list_item .typeIcon {
  width: 45px;
  height: 45px;
  margin-right: 8px;
}
.list .list_item .item_l,
.list .list_item .item_r {
  flex: 1;
}
.list .list_item .item_l .text1,
.list .list_item .item_r .text1 {
  font-size: 18px;
  color: #f8f8f8;
  line-height: 18px;
}
.list .list_item .item_l .text2,
.list .list_item .item_r .text2 {
  font-size: 16px;
  color: #f8f8f8;
  line-height: 16px;
  font-weight: 400;
}
.list .list_item .item_l .mb20,
.list .list_item .item_r .mb20 {
  margin-bottom: 8px;
}
.list .list_item .item_r {
  text-align: right;
}
.list .list_item .item_r .money {
  text-align: right;
  position: absolute;
  right: 20px;
  top: 50%;
  font-size: 20px;
  color: #0278EE;
  font-weight: 400;
  transform: translateY(-50%);
}
 

.pay {
  display: flex;

  .pay_l {
    flex: 1;
  }

  .pay_r {
    width: 96px;
    height: 96px;
    margin: 0 8px
  }

  image {
    width: 100%;
    height: 100%;
  }
}

.alertImg {
  width: 600rpx;
  height: 800rpx;
}
.no_data {
  margin-top: 10%;
  font-weight: 700;
}
.recharge_but {
    color: #fff;
    font-weight: 700;
    background: url(@/assets/img/float_btn.png) no-repeat left center;
    background-size: 100% 100%;
    padding: 5px;
    border-radius: 10px;
}
.alert {
  margin: 12px 0;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #fff;
  line-height: 16px;
}
.alert .title {
  font-size: 20px;
  color: #fff;
  text-align: center;
  line-height: 20px;
  font-weight: 700;
}
.alert .code {
  font-size: 15px;
  color: #FF4800;
  text-align: center;
  font-weight: 400;
  margin-top: 1%;
}  
.alert .info {
    padding: 10px 16px;
    width: 95%;
    background: #FFFBE8;
    font-size: 14px;
    color: #FB7311;
    line-height: 20px;
    font-weight: 400;
    margin: 0 auto;
    margin-top: 3%;
    border-radius: 17px
}
::v-deep .van-field__label {
  color: #fff;
}
::v-deep .van-popup{
  background-color: #151925;
}
::v-deep .van-field__control {
  color: #fff;
}
.alert .chonglist {
  margin-top: 12px;
  display: flex;
}
.alert .chonglist .item {
  padding: 5px 11px;
  border: 1px solid #cccccc;
  border-radius: 8px;
  margin-left: 5%;
}
.alert .alert_item {
  display: flex;
  padding: 0 16px;
  align-items: center;
  justify-content: space-between;
  margin-top: 2%;
  height: 48px;
  background-color: #151925;
  font-size: 18px;
}
.alert .alert_item .df {
  display: flex;
}
.alert .alert_item .alert_item_type {
  padding: 5px 11px;
  border: 1px solid #cccccc;
  border-radius: 8px;
  margin-left: 12px;
  background-color: #9c9c9c;
}
.alert .alert_item input {
  flex: 1;
  margin-left: 8px;
  font-size: 16px;
  text-align: right;
  background-color: transparent;
  border: none;
  color: #d1c8c8;
}
.alert .alert_item .placeholder {
  font-size: 16px;
  font-weight: 400;
  color: #BBBBBB;
}
.alert .select {
  background-color: #6aabbb !important;
  border: 1px solid #6aabbb !important;
}
.alert .imageBox {
  display: flex;
  flex-wrap: wrap;
  padding: 0 16px;
}
.alert .imageBox .image {
  margin-right: 12px;
  margin-bottom: 12px;
  width: 84px;
  height: 84px;
  border-radius: 8px;
}
.alert .imageBox .add {
    margin-right: 12px;
    margin-bottom: 12px;
    width: 84px;
    height: 84px;
    border-radius: 18px;
    text-align: center;
    background: #D8D8D8;
    font-size: 14px;
    color: #666666;
    font-weight: 400;
}
.alert .imageBox .add .jia {
  margin-top: 19px;
  margin-bottom: 8px;
}
.alert .button {
    background: #FA4743;
    border-radius: 8px;
    color: #fff;
    height: 46px;
    line-height: 46px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    text-align: center;
    width: 50%;
    margin: 0 auto;
    margin-top: 12px;
}
.alert .btn {
  display: flex;
  justify-content: space-between;
}
.alert .btn button {
  width: 45%;
}
.alert .btn button:first-child {
  border: 2rpx solid #FA4743;
  background: #fff;
  color: #FA4743;
}
.alert_item_real {
  display: flex;
  justify-content: flex-end;
  font-size: 10px;
  color: rgb(250, 223, 67);
  padding: 0 16px
}
</style>